export const baseAPIURL = "https://api.thethinkspaces.com/";
// export const baseAPIURL = "https://staging.thethinkspaces.com/";
export const webSocketEndpoint = "wss://api.thethinkspaces.com/ws";
// export const webSocketEndpoint = "wss://staging.thethinkspaces.com/ws";
